const UIStrategy = require('./ui_strategy');
const OPEN_CLASS = 'open';
const HIDDEN_CLASS = 'odf-hidden';
const BOUNCE_CLASS = 'bounce';
const BAGGAGE_SELECTOR_WRAPPER_CLASS = '.baggage_selector_wrapper';
const BAGGAGE_SELECTOR_CONTAINER_CLASS = '.baggage_selector_container';
const BAGGAGE_OPTIONS_LIST_CLASS = '.baggage_options_list';
const BAGGAGE_LIST_CLASS = '.baggage_list';
const CTA_CLASS = '.cta_confirm';
const DISABLED_BUTTON_CLASS = 'prisma-btn-disabled cta_disabled';
const RED_SPAN_OPEN = '<span class="odf-text-negative odf-strong">';
const RED_SPAN_CLOSED = '</span>';
const BUTTON_DISABLED_CLASS = 'prisma-btn-disabled cta_disabled';

class UIStrategyDrawer extends UIStrategy {
    constructor($selectorWrapper, ancillaryContainer, templates, keys, primeInfo) {
        super($selectorWrapper, ancillaryContainer, templates, keys, primeInfo);

        this.templates.list = templates.listDrawer;

        if (!this.primeInfo.isPrimeView) {
            this.templates.wrapper = templates.wrapperDrawer;
        } else if (this.primeInfo.isPrimeUser) {
            this.templates.wrapper = templates.wrapperDrawerRepeat;
        } else {
            this.templates.wrapper = templates.wrapperDrawerAcquisition;
        }

        this.bounced = false;
    }

    getDiscountDisplayed(discountPercentage, discountAmount) {
        if (!discountPercentage) {
            return '';
        }

        return discountAmount > 0 ?
            Odigeo.Utils.formatCurrency(discountAmount, {...Odigeo.Utils.Currency, decimalPlaces: 0})
            : `-${discountPercentage}%`;
    }

    getWrapperData() {
        const parentData = super.getWrapperData();
        const {discountPercentage, discountAmount} = this.primeInfo;

        return Odigeo._.merge({}, parentData, {
            discountDisplayed: this.getDiscountDisplayed(discountPercentage, discountAmount),
            keys: {
                bagsSelectorFooter: Odigeo.Utils.replaceCmsKeyArgs(this.keys.bagsSelectorFooter,
                    RED_SPAN_OPEN, RED_SPAN_CLOSED),
                discountKey: parentData.keys[discountAmount > 0 ? 'bagsSelectorDiscountSaveUpTo' : 'bagsSelectorDiscountUpTo'],
            },
        });
    }

    getSelectedBaggageData(evt) {
        return this.$selectorWrapper.find(`input:checked`).data();
    }

    toggle(parent, hide) {
        hide ? this.hide() : this.show();
    }

    show() {
        const $wrapper = this.$selectorWrapper.find(BAGGAGE_SELECTOR_WRAPPER_CLASS);
        const $container = this.$selectorWrapper.find(BAGGAGE_SELECTOR_CONTAINER_CLASS);
        const $cta = this.$selectorWrapper.find(CTA_CLASS);

        this.setBounce($container);
        this.setLabelsTriggers($cta);

        $cta.toggleClass(DISABLED_BUTTON_CLASS, true);
        $wrapper.toggleClass(HIDDEN_CLASS, false);
        Odigeo._.delay(() => {
            $container.toggleClass(OPEN_CLASS, true);
        }, 0);
    }

    hide() {
        const $wrapper = this.$selectorWrapper.find(BAGGAGE_SELECTOR_WRAPPER_CLASS);
        const $container = this.$selectorWrapper.find(BAGGAGE_SELECTOR_CONTAINER_CLASS);
        const $buttonsLabels = this.$selectorWrapper.find(`${BAGGAGE_LIST_CLASS} li label`);

        $container.get(0).addEventListener('transitionend', () => {
            $wrapper.toggleClass(HIDDEN_CLASS, true);
        }, {once: true});

        $container.toggleClass(OPEN_CLASS, false);

        $buttonsLabels.off('click');
    }

    setBounce($container) {
        if (!this.bounced) {
            $container.get(0).addEventListener('transitionend', () => {
                this.bounce();
            }, {once: true});
        }
    }

    bounce() {
        const $listWrapper = this.$selectorWrapper.find(BAGGAGE_OPTIONS_LIST_CLASS);
        const $list = this.$selectorWrapper.find(BAGGAGE_LIST_CLASS);

        if ($listWrapper.height() < $list.height() ) {
            this.bounced = true;
            $list.addClass(BOUNCE_CLASS);
        }
    }

    setLabelsTriggers($cta) {
        const $buttonsLabels = this.$selectorWrapper.find(`${BAGGAGE_LIST_CLASS} li label`);
        $buttonsLabels.one('click', () => {
            $cta.removeClass(BUTTON_DISABLED_CLASS);
        });
    }
}

module.exports = UIStrategyDrawer;
